module.exports = __webpack_public_path__ + "img/mets.a8980cf6.svg";